import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "root", staticClass: "custom-select" },
    [
      _c(
        VMenu,
        {
          staticClass: "custom-select__menu",
          attrs: {
            transition: false,
            attach: _vm.rootElement,
            "close-on-content-click": false,
            "offset-y": "",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attr }) {
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        { staticClass: "custom-select__activator" },
                        "div",
                        attr,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        VTextField,
                        _vm._b(
                          {
                            staticClass: "text-body-1 text--text",
                            attrs: {
                              label: _vm.label,
                              value: _vm.selectedItem.text,
                              readonly: "",
                              outlined: "",
                              "hide-details": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        VIcon,
                                        {
                                          staticClass: "custom-select__chevron",
                                        },
                                        [
                                          _vm._v(
                                            "\n              ui-icon-arrow-down\n            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          "v-text-field",
                          _vm.$attrs,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _vm._v(" "),
          _vm.search
            ? _c("menu-search", {
                attrs: { placeholder: "Найти" },
                model: {
                  value: _vm.searchQuery,
                  callback: function ($$v) {
                    _vm.searchQuery = $$v
                  },
                  expression: "searchQuery",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(VDivider),
          _vm._v(" "),
          _vm.searchResultsCount === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "custom-select__items custom-select__items_empty d-flex flex-column justify-center align-center",
                },
                [
                  _c("img", {
                    staticClass: "mb-5",
                    attrs: {
                      src: "/static/_v1/pd/icons/empty-search-result/common.svg",
                      width: "60",
                      height: "60",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-body-1 text--text" }, [
                    _vm._v("Мы ничего не нашли"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-select__items",
              class: {
                "custom-select__items_scroll":
                  _vm.scroll && _vm.items.length > 4,
              },
            },
            [
              _c("selection-list", {
                attrs: {
                  items: _vm.items,
                  value: _vm.value,
                  mandatory: _vm.mandatory,
                  "search-query": _vm.searchQuery,
                  "small-items": "",
                  hover: "",
                },
                on: { change: _vm.handleSelect },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }